export default __webpack_public_path__ + "assets/audios/client-name.mp3";